import {  Outlet } from 'react-router'
import Header from './__components/header';
import Footer from './__components/footer';
function Layout() {
  return (
    <div className="flex flex-col justify-between min-h-screen">
      <Header />
      <main className="flex flex-col flex-1 w-full">
        <Outlet />
      </main>
      <Footer/>
    </div>
  );
}

export default Layout
